import React, { useEffect, useState } from 'react';
import StaySearchForm from 'components/HeroSearchForm/(stay-search-form)/StaySearchForm';



const SearchWidget: React.FC = () => {
  const [, setLocationFilter] = useState<boolean>(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log(event);
      // Uncomment and update this line to check the expected origin
      // if (event.origin !== "http://your-expected-origin.com") {
      //   console.warn('Message received from an unknown origin:', event.origin);
      //   return;
      // }

      const { data } = event;
      if (data && typeof data.locationFilter !== 'undefined') {
        setLocationFilter(data.locationFilter);
      } else if (data?.payload?.event === 'setTraceUpdatesEnabled') {
        console.log('Received a trace update event:', data.payload);
      } else {
        console.warn('Unexpected message structure:', data);
      }
    };

    // Attach event listener for message events
    window.addEventListener("message", handleMessage);

    // Cleanup function to remove the event listener on component unmount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);



  return (
    <div style={{ backgroundColor: 'transparent' }}>
      <StaySearchForm  />

    </div>
  );
};

export default SearchWidget;